import React from 'react';
import ExtendSearchBase from './ExtendSearchBase';
import { Select, Checkbox } from '../../Controls';
import { SALE, COMMERCIALS } from '../../../consts';
import { getAgencies } from '../../../utils/dictionaries';

class SaleCommercials extends ExtendSearchBase {
  constructor (props) {
    super(props);
    this.displayName = 'saleCommercials';
    const dic = props.dictionary;

    this.floorPositionItems = dic.getFloorPositionItems(SALE, COMMERCIALS);
    this.applicationItems = dic.getApplicationItems(SALE, COMMERCIALS);
    this.agenciesList = getAgencies(props.agenciesList, this.displayName);
  }

  renderPanel () {
    return (<div>
      <div className='filter-section__container'>
        <h3 className='title'>Параметры недвижимости</h3>

        <div className='container__row'>
          <div className='container__column'>
          {this.renderInputGroup('Этаж', (
            <Select
              name='floorPositionId'
              items={this.floorPositionItems}
              value={this.getFilter('floorPositionId')}
              onUpdate={(_, id) => this.setFilter('floorPositionId', id)}
            />
            ), [
              {name: 'floorMin', placeholder: 'От', handler: this.getHandlerInt('floorMin', 3)},
              {name: 'floorMax', placeholder: 'До', handler: this.getHandlerInt('floorMax', 3)}
            ])}
          </div>
          <div className='container__column'>
            {this.renderInputGroup('Площадь, м²', null, [
              {name: 'squareTotalMin', placeholder: 'От', handler: this.getHandlerFloat('squareTotalMin', 7)},
              {name: 'squareTotalMax', placeholder: 'До', handler: this.getHandlerFloat('squareTotalMax', 7)}
            ])}
          </div>
          <div className='container__column'>
            {this.renderControlGroup('Расположение', (
              <div>
                <Checkbox
                  label='первая линия'
                  checked={this.getFilter('isFirstLine')}
                  onUpdate={(_, state) => this.setFilter('isFirstLine', state ? 1 : null)}
                />
                <Checkbox
                  label='отдельно стоящее здание'
                  checked={this.getFilter('isDetachedBuilding')}
                  onUpdate={(_, state) => this.setFilter('isDetachedBuilding', state ? 1 : null)}
                />
                <Checkbox
                  label='отдельный вход'
                  checked={this.getFilter('ownEntrance')}
                  onUpdate={(_, state) => this.setFilter('ownEntrance', state ? 1 : null)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className='filter-section__container'>
        <h3 className='title'>Прочие параметры</h3>

        <div className='container__row'>
          <div className='container__column'>
            {this.getUserIsAdmin() && this.renderMultiSelect('Приложения', 'sourceAppId', this.applicationItems, true)}
            {this.renderMultiSelect('Агентство / застройщик', 'agencyId', this.agenciesList, true, 'Неважно', true)}
          </div>
          <div className='container__column'>
            {this.renderInputGroup('Поиск в описании', null, [
              {name: 'description', placeholder: 'Ключевые слова', handler: this.getHandlerString('description')}
            ])}
            {this.renderInputGroup('Контактный телефон', null, [
              {name: 'contactPhone', placeholder: '123 456 78 90', handler: this.getHandlerInt('contactPhone')}
            ])}
          </div>
          <div className='container__column'>
            {this.renderInputGroup('Номер объявления', null, [
              {name: 'id', placeholder: '12345678', handler: this.getHandlerInt('id')}
            ])}
            {this.renderControlGroup('Дополнительно', (
              <div>
                <Checkbox
                  label='Частные объявления'
                  checked={this.getFilter('onlyOwners')}
                  onUpdate={(_, state) => this.setFilter('onlyOwners', state ? 1 : null)}
                />
                <Checkbox
                  label='С фото'
                  checked={this.getFilter('hasPhoto')}
                  onUpdate={(_, state) => this.setFilter('hasPhoto', state ? 1 : null)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>);
  }
}

export default SaleCommercials;



// WEBPACK FOOTER //
// ./src/ui/Search/ExtendSearch/SaleCommercials.jsx